import { redirect } from "react-router-dom";
import { fetchHomePage, fetchPreviewItem, fetchSingle } from "@/api";

// const decodeTitle = (title) => {
//   const txt = document.createElement("textarea");
//   txt.innerHTML = title;
//   return txt.value;
// };

// Shapes a raw REST post item into whatever the matching route's component
// expects from useLoaderData(). Shared by routerGuard (published content,
// fetched by slug) and previewLoader (draft/private content, fetched by id)
// so the two paths can never render posts differently.
const mapPostToLoaderData = (type, post) => {
  if (type === "pages") {
    return post?.acf?.modules;
  } else if (type === "case-studies") {
    return {
      modules: post?.acf?.modules || [],
      meta: {
        title: post?.title?.rendered,
        featured_image: post?.featured_image_url,
        categories: post?.case_studies_category_info,
        excerpt: post?.excerpt?.rendered,
        slug: post?.slug,
      },
    };
  } else if (type === "open-roles") {
    return {
      modules: post?.acf?.modules || [],
      meta: {
        title: post?.title?.rendered,
        featured_image: post?.featured_image_url,
        excerpt: post?.excerpt?.rendered,
        slug: post?.slug,
      },
    };
  }

  return post;
};

export const routerGuard = async ({ routeData = {}, type = null, homePage = false }) => {
  // Published previews keep their permalink; they do not pass through the
  // homepage preview loader. Use the request URL so normal SPA navigation
  // stops previewing even though the localized context remains on window.
  if (
    window.__NS_PREVIEW__ &&
    type === window.__NS_PREVIEW__.rest_base &&
    routeData.request &&
    new URL(routeData.request.url).searchParams.get("preview") === "true"
  ) {
    return previewLoader();
  }

  const request = {
    type,
    params: {
      slug: routeData.params.slug,
    },
  };
  if (homePage) {
    const data = await fetchHomePage();
    return data.data.data.modules;
  } else if (type === "pages" || type === "case-studies" || type === "open-roles") {
    const data = await fetchSingle(request);
    if (data.data.length === 0) return redirect("/404");
    return mapPostToLoaderData(type, data.data[0]);
  } else {
    if (type === null) return routeData.params;
    const data = await fetchSingle(request);
    if (data.data.length === 0) return redirect("/404");
    return data.data[0];
  }
};

// Loader for WordPress's native Preview (?p=ID&preview=true). preview.php
// localizes window.__NS_PREVIEW__ with the parent and optional autosave IDs,
// REST base and REST nonce needed to fetch preview content authenticated as the
// logged-in editor. See routes.jsx for how rest_base picks the component.
export const previewLoader = async () => {
  const { id, rest_base: restBase, nonce, autosave_id: autosaveId } = window.__NS_PREVIEW__ || {};

  if (!id || !restBase || !nonce) return redirect("/404");

  const { data: post } = await fetchPreviewItem({ restBase, id, nonce, autosaveId });

  const data = mapPostToLoaderData(restBase, post) || [];
  // Preserve the component loader shape, including page module arrays.
  data.previewTitle = post.title?.raw ?? post.title?.rendered ?? "";
  return data;
};
